window.dataLayer = window.dataLayer || []; 
function gtag(){dataLayer.push(arguments);} 

exports. trackUser=function(trackId){
 gtag('js', new Date()); 
 gtag('Event', trackId);
}